import { useConfig } from "@jti/app-context/useConfig";
import type { OtPurposesByCategoryAndUser } from "@jti/fe-common";
import { useConsentReminder } from "@jti/ui";

import { getConsentReminderConfig } from "../utils/getConsentReminderConfig";

type ConsentQueryState = {
  data?: OtPurposesByCategoryAndUser[];
  isLoading: boolean;
  isError: boolean;
};

export const useCheckoutConsentReminder = (
  popupConfig: Parameters<typeof getConsentReminderConfig>[0],
  { data, isLoading, isError }: ConsentQueryState
) => {
  const { consentReminderMode } = useConfig();
  const { isConsentReminderVisible, consentType, closeConsentReminder } = useConsentReminder({
    config: getConsentReminderConfig(popupConfig, consentReminderMode),
    consents: data,
    isLoading,
    isError,
  });

  return {
    isConsentPopUpVisible: isConsentReminderVisible,
    consentType,
    closeConsentsPopUp: closeConsentReminder,
  };
};
